<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title ">Novo</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-10">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.deadline != '', 'has-danger' : validation.deadline != '' }">
                                        <label for="deadline" class="bmd-label-floating">Prazo</label>
                                        <input refs="deadline" type="text" class="form-control" v-model="form.deadline" />
                                        <label v-if="validation.deadline != ''" id="deadline-error" class="error" for="deadline">{{ validation.deadline }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.quotas != '', 'has-danger' : validation.quotas != '' }">
                                        <label for="quotas" class="bmd-label-floating">Cotas *</label>
                                        <input refs="quotas" type="text" v-numeric-only class="form-control" v-model="form.quotas" />
                                        <label v-if="validation.quotas != ''" id="quotas-error" class="error" for="quotas">{{ validation.quotas }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled"
                                         v-bind:class="{'has-danger' : validation.meeting_at != '' }">
                                        <label for="meeting_at" class="bmd-label-floating">Assembléia *</label>
                                        <date-picker v-model="form.meeting_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data" :not-before="new Date()"></date-picker>
                                        <label v-if="validation.meeting_at != ''" id="meeting_at-error" class="error" for="meeting_at" style="clear: both; display: block;">{{ validation.meeting_at }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled"
                                         v-bind:class="{'has-danger' : validation.administrator_id != '' }">
                                        <label for="administrator_id" class="bmd-label-floating">Administradora *</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="administrators"
                                            v-model="form.administrator_id"
                                            option-value="id"
                                            option-text="name"
                                            placeholder="Escolha uma Administradora">
                                        </model-list-select>
                                        <label v-if="validation.administrator_id != ''" id="administrator_id-error" class="error" for="administrator_id" style="clear: both; display: block;">{{ validation.administrator_id }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                v-bind:to-back="{name: 'groups.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {
            administrators: {
                set(_list) {

                },
                get() {
                    return this.$store.state.administrators.itens;
                }
            }
        },
        created() {
            var self = this;

            self.administrators = [];

            self.getData();
        },
        data() {
            return {
                form: {
                    deadline: '',
                    name: '',
                    quotas: '',
                    meeting_at: '',
                    administrator_id: ''
                },
                validation: {
                    deadline: '',
                    name: '',
                    quotas: '',
                    meeting_at: '',
                    administrator_id: ''
                }
            };
        },
        methods: {
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');

                    self.$notify.error("Falha na comunicação com API!");
                    self.$router.push({'name': 'groups.index'});
                });
            },
            onSubmit(_ev) {
                var self = this;
                var valid = true;
                self.validation.name = '';
                self.validation.quotas = '';
                self.validation.meeting_at = '';
                self.validation.administrator_id = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.quotas == '') {
                    self.validation.quotas = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.meeting_at == '') {
                    self.validation.meeting_at = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.administrator_id == '') {
                    self.validation.administrator_id = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');

                    const response = self.$store.dispatch('groups/add', this.form);

                    response.then(function (_res) {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Grupo cadastrado com sucesso!");
                        self.$router.push({'name': 'groups.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');                    
                        self.$notify.error(err.data.message)
                    });
                }

                _ev.preventDefault();
            }
        }
    };
</script>